interface HorizontalDividerProps {
  className?: string;
}

export const HorizontalDivider = ({ className }: HorizontalDividerProps) => {
  return <div className={`w-full h-[1px] bg-grey400 ${className ?? ''}`} />;
};
